import { Card, CardContent, Typography } from "@mui/material";

const PartnerStatCard = ({ label, value }) => (
  <Card variant="outlined" sx={{ height: "100%" }}>
    <CardContent>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="h6" fontWeight={700} sx={{ mt: 0.5 }}>
        {value}
      </Typography>
    </CardContent>
  </Card>
);

export default PartnerStatCard;
